import { useState } from "react";
import React from "react";
import ApiContext from "./api-context";
function ApiProvider(props) {
  const [apiData, setApi] = useState("");

  function changeApi(val) {
    setApi(val);
  }

  const StateContext = {
    apiData: apiData,
    changeApi: changeApi,
  };

  return (
    <ApiContext.Provider value={StateContext}>
      {props.children}
    </ApiContext.Provider>
  );
}

export default ApiProvider;
